/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Us_CanadaInputs */

const en_claims_us_canada = /** @type {(inputs: Claims_Us_CanadaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. and Canada`)
};

const fr_claims_us_canada = /** @type {(inputs: Claims_Us_CanadaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`États-Unis et Canada`)
};

/**
* | output |
* | --- |
* | "U.S. and Canada" |
*
* @param {Claims_Us_CanadaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_us_canada = /** @type {((inputs?: Claims_Us_CanadaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Us_CanadaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_us_canada(inputs)
	return fr_claims_us_canada(inputs)
});